import React from "react"
import ReactDOM from "react-dom"
import SEOBlock from "./seo-block"

export default class SeoBlockModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.data = JSON.parse(elem.dataset.model)
    this.init()
    return self
  }

  init() {
    const self = this
    if (self.data) {
      if (self.data.invert) {
        ReactDOM.render(<SEOBlock {...self.data} modifier="seo-block--inverted" />, self.elem)
      } else {
        ReactDOM.render(<SEOBlock {...self.data} />, self.elem)
      }
    }
  }
}
